<template lang="pug">
  main
    NavBarAdmin
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Almacenes
              | &nbsp
              a.button.is-dark.is-rounded(@click='backPage')
                i.fas.fa-times
            br
        .columns.has-text-centered.is-centered.is-multiline.has-text-black.is-mobile
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold IRGE
                br
                a.button.is-dark.is-rounded(@click="irAlmacen('IRGE-ALM')") Entrar
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold TPA
                br
                a.button.is-dark.is-rounded(@click="irAlmacen('TPA-ALM')") Entrar
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold EB04
                br
                a.button.is-dark.is-rounded(@click="irAlmacen('EB04-ALM')") Entrar
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold EB03
                br
                a.button.is-dark.is-rounded(@click="irAlmacen('EB03-ALM')") Entrar
        .columns.has-text-centered.is-centered.is-multiline.has-text-black.is-mobile
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold EB02
                br
                a.button.is-dark.is-rounded(@click="irAlmacen('EB02-ALM')") Entrar
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold EB01
                br
                a.button.is-dark.is-rounded(@click="irAlmacen('EB01-ALM')") Entrar
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold EB00
                br
                a.button.is-dark.is-rounded(@click="irAlmacen('EB00-ALM')") Entrar
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold CORPO
                br
                a.button.is-dark.is-rounded(@click="irAlmacen('CORP-ALM')") Entrar
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold EB04 GIA
                br
                a.button.is-dark.is-rounded(@click="irAlmacen('EB04-ALG')") Entrar
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold TPA GIA
                br
                a.button.is-dark.is-rounded(@click="irAlmacen('TPA-ALS')") Entrar
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold CORPO GIA
                br
                a.button.is-dark.is-rounded(@click="irAlmacen('CORP-ALG')") Entrar
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold IRGE Activos
                br
                a.button.is-dark.is-rounded(@click="irAlmacen('IRGE-ALA')") Entrar
        .columns.column-blanco
</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarAdmin from '@/components/layout/NavBarAdmin.vue'
import NotificacionConst from '@/components/shared/NotificacionConst.vue'
import { mapState } from 'vuex'

export default {
  name: 'ListaAlmacenes',
  components: { Loader, NavBarAdmin, NotificacionConst },
  data () {
    return {
      isLoading: false,
    }
  },
  methods: {
    obtenerUser() {
      if (Object.keys(this.userLogin).length === 0) {
        this.$router.push('/')
      }
    },
    irAlmacen (dest) {
      this.$store.commit('selectAlmacen', dest)
      this.$router.push(`/Inventario/Almacen`)
    },
    backPage () {
      this.$router.back()
    },
  },
  computed: {
    ...mapState(['logueado', 'userLogin'])
  },
  created () {
    this.obtenerUser()
  },
}
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }

  .image {
    display: inline-block;
  }
  .card:hover {
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
  }
  .card {
    color: #54545c;
  }

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/ListaAlmacenes.vue